import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { SnackbarContent, useSnackbar } from 'notistack';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import { getContactFullName } from '../../../../helpers/contactHelpers';
import { useRootStore } from '../../../../mobx/bridge';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      minWidth: '344px !important',
    },
  },
  card: {
    backgroundColor: '#3ca8d9',
    width: '100%',
  },
  typography: {
    color: '#ffffff',
  },
  actionRoot: {
    padding: '8px 8px 8px 16px',
  },
  icons: {
    color: '#ffffff',
    marginLeft: 'auto !important',
  },
  expand: {
    padding: '8px 8px',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    color: '#ffffff',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
    color: '#ffffff',
  },
  collapse: {
    padding: 16,
  },
  checkIcon: {
    fontSize: 20,
    color: '#b3b3b3',
    paddingRight: 4,
  },
  button: {
    padding: 0,
    textTransform: 'none',
  },
}));

const CustomSnackbar = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();
  const [expanded, setExpanded] = useState(false);
  const { id, message } = props;
  const { sendingEvents } = useRootStore();
  const { t } = useTranslation();

  const parsedMessage = JSON.parse(message);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleDismiss = () => {
    sendingEvents.socketEmitRemovePersistentNotification(parsedMessage);
    closeSnackbar(id);
  };

  const iconButtonClassname = [classes.expand];
  if (expanded) {
    iconButtonClassname.push(classes.expandOpen);
  }

  const senderFullName = getContactFullName(
    parsedMessage.Sender,
    parsedMessage.Channel?.CustomerPhoneNumber
  );

  return (
    <SnackbarContent ref={ref} className={classes.root}>
      <Card className={classes.card}>
        <CardActions classes={{ root: classes.actionRoot }}>
          <Typography variant="subtitle2" className={classes.typography}>
            {t('CustomSnackbar.NewMessageFrom', {
              contactName: senderFullName,
            })}
          </Typography>

          <div className={classes.icons}>
            <IconButton
              aria-label={t('CustomSnackbar.ShowMore')}
              className={iconButtonClassname.join(' ')}
              onClick={handleExpandClick}
            >
              <ExpandMoreIcon />
            </IconButton>

            <IconButton className={classes.expand} onClick={handleDismiss}>
              <CloseIcon />
            </IconButton>
          </div>
        </CardActions>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Paper className={classes.collapse}>
            {parsedMessage.FilePath ? t('CustomSnackbar.SentFile') : parsedMessage.MessageText}
          </Paper>
        </Collapse>
      </Card>
    </SnackbarContent>
  );
});
CustomSnackbar.whyDidYouRender = true;
CustomSnackbar.displayName = 'CustomSnackbar';

export default React.memo(CustomSnackbar);
